import { AlertsSubscription } from "../../graphql/generated/operations";

/**
 * @param {AlertsSubscription | undefined} data
 * @returns {any[] | undefined}
 */
export const formatter = (data) => data?.alerts;
